import { type PaginationResponseEntity } from '@/core/infrastructure/schemas/pagination/PaginationSchema.ts'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'
import { z } from 'zod'

/**
 * Implémentation du type PaginationResponseEntity
 */
export default class PaginationResponse<T> {
  readonly content: T[]
  readonly totalElements: number
  readonly totalPages: number
  readonly page: number
  readonly size: number
  readonly hasNext: boolean
  readonly hasPrevious: boolean

  constructor(pagination: PaginationResponseEntity) {
    this.content = pagination.content as T[]
    this.totalElements = pagination.totalElements
    this.totalPages = pagination.totalPages
    this.page = pagination.page
    this.size = pagination.size
    this.hasNext = pagination.hasNext
    this.hasPrevious = pagination.hasPrevious
  }

  public copy(update: Partial<PaginationResponse<T>>): PaginationResponse<T> {
    return new PaginationResponse<T>({
      ...this,
      ...update
    })
  }

  public static create<T>(
    data: unknown,
    schema: z.ZodTypeAny,
    build: (data: PaginationResponseEntity) => PaginationResponse<T>
  ): PaginationResponse<T> {
    return EntityValidator.validateAndCreateFactory(schema, data, build, 'PaginationResponse')
  }
}